export function InspectionIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10L16.59 8.58L10 15.17L7.41 12.59L6 14L10 18L18 10ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
        fill="#47464F"
      />
    </svg>
  );
}

export function InspectionIconBlue() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10L16.59 8.58L10 15.17L7.41 12.59L6 14L10 18L18 10ZM19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C4.86 4 4.73 4.01 4.6 4.04C4.21 4.12 3.86 4.32 3.59 4.59C3.41 4.77 3.26 4.99 3.16 5.23C3.06 5.46 3 5.72 3 6V20C3 20.27 3.06 20.54 3.16 20.78C3.26 21.02 3.41 21.23 3.59 21.42C3.86 21.69 4.21 21.89 4.6 21.97C4.73 21.99 4.86 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 3.75C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25C11.59 5.25 11.25 4.91 11.25 4.5C11.25 4.09 11.59 3.75 12 3.75ZM19 20H5V6H19V20Z"
        fill="#eef2ff"
      />
    </svg>
  );
}

export function InspectionIconBlueSquare() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0" y="0" width="32" height="32" rx="6" fill="white" />

      <rect x="6" y="6" width="20" height="20" rx="3" fill="#cdd6ff" />
    </svg>
  );
}

export function IncidentReportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9Z"
        fill="#47464F"
      />
      <path
        d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
        fill="#47464F"
      />
      <path d="M11 7H13V14H11V7Z" fill="#47464F" />
    </svg>
  );
}

export function FuelMaintenanceReportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.52 7.23L19.53 7.22L15.81 3.5L14.75 4.56L16.86 6.67C15.92 7.03 15.25 7.93 15.25 9C15.25 10.38 16.37 11.5 17.75 11.5C18.11 11.5 18.44 11.42 18.75 11.29V18.5C18.75 19.05 18.3 19.5 17.75 19.5C17.2 19.5 16.75 19.05 16.75 18.5V14C16.75 12.9 15.85 12 14.75 12H13.75V5C13.75 3.9 12.85 3 11.75 3H5.75C4.65 3 3.75 3.9 3.75 5V21H13.75V13.5H15.25V18.5C15.25 19.88 16.37 21 17.75 21C19.13 21 20.25 19.88 20.25 18.5V9C20.25 8.31 19.97 7.68 19.52 7.23ZM11.75 19H5.75V12H11.75V19ZM11.75 10H5.75V5H11.75V10ZM17.75 10C17.2 10 16.75 9.55 16.75 9C16.75 8.45 17.2 8 17.75 8C18.3 8 18.75 8.45 18.75 9C18.75 9.55 18.3 10 17.75 10Z"
        fill="#47464F"
      />
    </svg>
  );
}

export function MaintenanceReportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6556 18.9896L13.5756 9.90957C14.5056 7.56957 14.0256 4.80957 12.1356 2.90957C9.83562 0.609575 6.25562 0.399574 3.70562 2.25957L7.54562 6.10957L6.12562 7.51957L2.29562 3.68957C0.435616 6.22957 0.645616 9.81957 2.94562 12.1096C4.80562 13.9696 7.51562 14.4596 9.83562 13.5896L18.9456 22.6996C19.3356 23.0896 19.9656 23.0896 20.3556 22.6996L22.6556 20.3996C23.0556 20.0196 23.0556 19.3896 22.6556 18.9896ZM19.6556 20.5896L10.1956 11.1296C9.58562 11.5796 8.90562 11.8496 8.19562 11.9496C6.83562 12.1496 5.40562 11.7396 4.36562 10.6996C3.41562 9.75957 2.97562 8.49957 3.04562 7.25957L6.13562 10.3496L10.3756 6.10957L7.28562 3.01957C8.52562 2.94957 9.77562 3.38957 10.7256 4.32957C11.8056 5.40957 12.2156 6.89957 11.9656 8.28957C11.8456 8.99957 11.5456 9.65957 11.0856 10.2496L20.5356 19.6996L19.6556 20.5896Z"
        fill="#47464F"
      />
    </svg>
  );
}

export function InspectionIconMobile() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8.82 13.05L7.4 14.46L10.94 18L16.6 12.34L15.19 10.93L10.95 15.17L8.82 13.05Z"
        fill="#47464F"
      />
    </svg>
  );
}
